export default "__VITE_PUBLIC_ASSET__9b022882__"